import '../../styling/dialog.css'

import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"

import { strings } from "../../strings"
import { balconyDuration } from '../../config'

const ConfirmBalconyDialog = ({ open, closeConfirm, closeCancel, event }) => {

    const eventStart = event && new Date(event.start)
    const month = event && eventStart.getMonth() + 1
    const dateFormat = event && eventStart.getDate() + "/" + month + ", " + eventStart.getHours() + ":00-" + (eventStart.getHours() + balconyDuration) + ":00"

    let w = window.innerWidth
    let h = window.innerHeight

    return (
        <Dialog className="confirmation-dialog" open={open}>
            <DialogTitle style={{ width: `${w > h ? '30vw' : '65vw'}` }}>{strings.dialogs.confirmationTitle}</DialogTitle>
           
            <DialogContent >
                <DialogContentText>
                    {event && event.facility}
                    <br />
                    {event && dateFormat}
                </DialogContentText>
            </DialogContent>

            <DialogActions className="dialog-actions">
                <span className="cancel-dialog" onClick={closeCancel} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancel}
                </span>
                <span className={"confirm-dialog"}
                    style={{ cursor: "pointer" }}
                    onClick={() => closeConfirm()} >
                    {strings.dialogs.confirmation}
                </span>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmBalconyDialog
